/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { LinksContainer } from "@components";

import "./styles.scss";

type Props = $Exact<{
  hiddenLinks?: $Exact<{
    shiftPattern?: LinkItem,
    interactions?: LinkItem,
    notesToManager?: LinkItem,
    additionalInfo?: LinkItem,
    notifications?: LinkItem,
    rtwInterview?: LinkItem,
    documents?: LinkItem,
    alertsTriggered?: LinkItem,
  }>,
  ...PropsFromLocalize,
}>;

type LinkItem = $Exact<{
  hidden?: boolean,
  onClick?: () => void,
}>;

export const AbsenceDetailsLinks = (props: Props) => (
  <LinksContainer
    className="links-container mb-3 flex-wrap absence-details-links"
    itemClassName="mt-2 text-orange"
    items={[
      {
        label: props.t("SHIFT_PATTERN"),
        hidden: props.hiddenLinks && (props.hiddenLinks.shiftPattern || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.shiftPattern || {}).onClick,
      },
      {
        label: props.t("ADDITIONAL_INFO"),
        hidden: props.hiddenLinks && (props.hiddenLinks.additionalInfo || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.additionalInfo || {}).onClick,
      },
      {
        label: props.t("ALERTS"),
        hidden: props.hiddenLinks && (props.hiddenLinks.alertsTriggered || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.alertsTriggered || {}).onClick,
      },
      {
        label: props.t("NOTIFICATIONS"),
        hidden: props.hiddenLinks && (props.hiddenLinks.notifications || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.notifications || {}).onClick,
      },
      {
        label: props.t("RTW_INTERVIEW"),
        hidden: props.hiddenLinks && (props.hiddenLinks.rtwInterview || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.rtwInterview || {}).onClick,
      },
      {
        label: props.t("NOTES"),
        hidden: props.hiddenLinks && (props.hiddenLinks.notesToManager || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.notesToManager || {}).onClick,
      },
      {
        label: props.t("DOCUMENTS"),
        hidden: props.hiddenLinks && (props.hiddenLinks.documents || {}).hidden,
        onClick: props.hiddenLinks && (props.hiddenLinks.documents || {}).onClick,
      },
    ]}
  />
);

export default localize()(AbsenceDetailsLinks);
